import { render } from "./TransactionDialog.vue?vue&type=template&id=00964078&scoped=true"
import script from "./TransactionDialog.vue?vue&type=script&lang=js"
export * from "./TransactionDialog.vue?vue&type=script&lang=js"

import "./TransactionDialog.vue?vue&type=style&index=0&id=00964078&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src1847379700/src/basejumper-amplify/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00964078"]])

export default __exports__